import React from "react";
import { Route, Redirect, RouteProps } from "react-router";
import { inject, observer } from "mobx-react";
import { authErrorRoute, IAuthStore } from "@src/Stores/Auth/types";

interface IProps extends RouteProps {
  component: React.SFC<any> | React.ComponentClass<any>;
  auth?: IAuthStore;
}

const PrivateRoute = inject("auth")(
  observer(({ component: Component, auth, ...rest }: IProps) => {
    return (
      <Route
        {...rest}
        render={(props) =>
          // allow redirect to login page for logged in users,
          // for cases when auth request is coming from an outside app
          (auth.isAuthorized && !props.location.pathname.match(authErrorRoute)) ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                search: props.location.search,
                state: { from: props.location },
              }}
            />
          )
        }
      />
    );
  })
);

export default PrivateRoute;
